import initialState from '../store/initialstate';
import C from '../constants/SRview';

export default (state = initialState().SRview, action = null) => {
    let srInfo;
    switch (action.type) {
        case C.GET_SR_DATA: {
            let {info, ...rest} = action.payload;
            srInfo = info.reduce((total, current) => {
                // timers should be converted from timestamp to hh:mm
                // detecting them by key, it should start with 'timer' for all
                if (/^timer/.test(current.key) && current.type === 'numeric') {
                    current.valueCaption = millisToHoursAndMinutes(current.valueCaption);
                }
                total[current.key] = {
                    key: current.key,
                    value: current.value,
                    valueCaption: current.valueCaption,
                    keyCaption: current.keyCaption,
                    type: current.type,
                    valueClass: current.valueClass
                };
                return total;
            }, {});

            Object.assign(srInfo, rest);

            switch (srInfo.status.valueClass) {
                case 0:
                    srInfo.status.valueClass = 'active';
                    break;
                case 1:
                    srInfo.status.valueClass = 'closed';
                    break;
                case 2:
                    srInfo.status.valueClass = 'deleted';
                    break;
                default:
                    srInfo.status.valueClass = '';
                    break;
            }

            return state.set(C.SR_DATA, srInfo);
        }

        case C.GET_SSP_SR_VIEW: {
            state = state.set(C.SSP_SR_VIEW, action.payload);

            // extract tabs order from SSP_SR_VIEW
            let SSPsrViewArray = action.payload;
            let tabsArray = ['notes','attachments','messages','activities'];
            let SRviewTabsToDisplay = [];

            for (let i = 0; i < SSPsrViewArray.length; i++) {
                if (tabsArray.indexOf(SSPsrViewArray[i].id) > -1) {
                    let arrayKey = SSPsrViewArray[i].index;
                    let arrayValue = SSPsrViewArray[i].id;
                    SRviewTabsToDisplay.splice(arrayKey,0,arrayValue);
                }
            }
            state = state.set(C.TABS_ORDER, SRviewTabsToDisplay);

            return state;
        }

        default:
            return state;
    }
}

function millisToHoursAndMinutes(millis) {
    millis = millis / (1000 * 60);
    let str = '';
    let h = Math.floor(millis / 60);
    let m = Math.floor(millis % 60);
    if (h < 10) {
        str = '0' + h + ':';
    } else {
        str = h + ':';
    }
    if (m < 10) {
        str = str + '0' + m;
    } else {
        str = str + m;
    }
    return str;
}



// WEBPACK FOOTER //
// ./reducers/SRview.js